import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      transition={{ delay: 1 }} 
      className="text-center py-8"
    >
      <div className="flex flex-col items-center gap-4">
        <a
          href="/signup"
          className="px-6 py-2.5 rounded-full bg-black text-white text-sm font-medium hover:bg-gray-800 transition-colors"
        >
          Get Your Custom Pitch URL
        </a>
        
        <div className="text-xs text-gray-400 mb-2">
          Go live in seconds
        </div>
        
        <div className="flex items-center gap-1.5 text-xs text-gray-400">
          <div className="w-1.5 h-1.5 rounded-full bg-gray-300"></div>
          <span>
            Built with{' '}
            <a 
              href="https://decklink.co" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-gray-600 transition-colors"
            >
              decklink.co
            </a>
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default Footer; 